import $ from 'jquery';
export default class CustomerCode {
    static init($root = $('body')) {
        $root.on('click', '.js__customer-code-generate', event => {
            const $target = $(event.currentTarget);
            const { url, codeInput } = $target.data();
            this.customerGenerateCode(url, $target.parents('form'), codeInput);
        });
    }
    static customerGenerateCode(url, $container, codeInput) {
        const $items = $container.find('button, input').not('input:hidden');
        $.ajax({
            url: url,
            beforeSend: () => {
                $items.prop('disabled', true);
                $container.find('.input').addClass('loading');
            },
        })
            .done(result => {
            $(codeInput).val(result);
        })
            .always(() => {
            $items.prop('disabled', false);
            $container.find('.input').removeClass('loading');
        });
    }
}
